import CityPageTemplate from './CityPageTemplate';

const cityData = {
  cityName: "Eagan",
  metaDescription: "Professional plumber in Eagan, MN. Bruce Nelson Plumbing & Heating provides residential and commercial plumbing, boiler service, and water heater repair. Call 651-738-9354.",
  heroTitle: "Plumber in Eagan, MN",
  heroSubtitle: "Dependable plumbing and heating services for Eagan homes and businesses.",
  introduction: "Eagan residents have trusted Bruce Nelson Plumbing & Heating for reliable plumbing services since 1976. From the neighborhoods near Lebanon Hills Regional Park to the business corridor along I-35E, we provide comprehensive plumbing solutions for all of Eagan. Our technicians are experienced with both residential and commercial plumbing needs.",
  services: [
    {
      title: "Residential Plumbing",
      description: "Complete home plumbing services for Eagan residents.",
      link: "/services/residential"
    },
    {
      title: "Commercial Plumbing",
      description: "Professional plumbing for Eagan businesses and commercial properties.",
      link: "/services/commercial"
    },
    {
      title: "Boiler Service",
      description: "Expert boiler installation, repair, and maintenance in Eagan.",
      link: "/services/boilers"
    },
    {
      title: "Water Heater Repair",
      description: "Quick water heater repair and replacement for Eagan homes.",
      link: "/services/water-heaters"
    },
    {
      title: "Drain Cleaning",
      description: "Professional drain cleaning services throughout Eagan.",
      link: "/services"
    },
    {
      title: "Air Conditioning",
      description: "AC installation and repair to keep your Eagan home comfortable.",
      link: "/services/air-conditioning"
    }
  ],
  whyChooseUs: [
    "Nearly 50 years of service in the Twin Cities metro",
    "Licensed and insured Minnesota plumbing contractors",
    "Experienced with Eagan's diverse housing stock",
    "Fair, transparent pricing on all services",
    "Prompt service to all Eagan neighborhoods",
    "Excellent reputation with Eagan homeowners"
  ],
  serviceAreas: [
    { name: "Saint Paul", link: "/plumber-saint-paul" },
    { name: "Minneapolis", link: "/plumber-minneapolis" },
    { name: "Rosemount", link: "/plumber-rosemount" },
    { name: "Woodbury", link: "/plumber-woodbury" },
    { name: "Oakdale", link: "/plumber-oakdale" },
    { name: "Maplewood", link: "/plumber-maplewood" }
  ],
  testimonial: {
    text: "BNPH responded quickly when our water heater failed. They had a new one installed the same day. Great service and fair pricing!",
    author: "Mike R."
  }
};

const EaganPage = () => <CityPageTemplate cityData={cityData} />;

export default EaganPage;
